import { BATTLE_STATES, COMMANDERS } from './../../LevelManager/store.d'
import { SEL_BATTLE_STATE, SEL_SELECTED_SPELL } from './../../LevelManager/selectors'
import { ThreeEvent } from '@react-three/fiber'
import { useSceneStore } from '../../../a.scenes/GameScene/store'
import Interactive from '../../../e.elements/GameElements/classes/Interactive'
import { GameObject3D, GAME_OBJECTS } from '../../../e.elements/GameElements/classes/types'
import getGameElementFromObj from '../../../e.elements/GameElements/helpers/getGameElementFromObj'
import { SPELL_TARGET_TYPE } from '../../LevelManager/store.d'
import Minion from '../../../e.elements/GameElements/classes/Minion'
import { Sorcery } from '../../../d.controllers/SpellsController'

// stack of events after an interaction
const interactionStack: ThreeEvent<Event>[] = []
// resolve the closest event from multiple targets
const resolveInteraction = () => {
  const battleState = SEL_BATTLE_STATE(useSceneStore.getState())
  if(battleState !== BATTLE_STATES.ONGOING) {
    console.warn('interaction not allowd')
    interactionStack.length = 0
    return false
  }
  // =======================================================
  // resolves first spell casting if any.
  const spell = SEL_SELECTED_SPELL(useSceneStore.getState())

  if (spell) {
    // filter interactive elements by spell target type
    const eventsRelatedToAvailableSpellTargets = interactionStack.filter((e: ThreeEvent<Event>) => {
      const gameObject = getGameElementFromObj(e.eventObject as GameObject3D) as Minion
      switch (spell.targetType) {
        case SPELL_TARGET_TYPE.ANY_CREATURE:
          return gameObject.isClass(GAME_OBJECTS.MINION) && !gameObject.isInvalidated
        case SPELL_TARGET_TYPE.MY_CREATURES:
          return gameObject.isClass(GAME_OBJECTS.MINION) && gameObject.owner === COMMANDERS.PLAYER && !gameObject.isInvalidated
        case SPELL_TARGET_TYPE.ENEMY_CREATURES:
          return gameObject.isClass(GAME_OBJECTS.MINION) && gameObject.owner !== COMMANDERS.PLAYER && !gameObject.isInvalidated
        case SPELL_TARGET_TYPE.ENEMY_TREASURE:
          return gameObject.isClass(GAME_OBJECTS.TREASURE) && gameObject.owner !== COMMANDERS.PLAYER
        case SPELL_TARGET_TYPE.MY_TREASURE:
          return gameObject.isClass(GAME_OBJECTS.TREASURE) && gameObject.owner === COMMANDERS.PLAYER
        case SPELL_TARGET_TYPE.TERRAIN:
          return gameObject.isClass(GAME_OBJECTS.TILE)
        case SPELL_TARGET_TYPE.GAME:
          return true
        default:
          return false
      }
    })

    // length > 0 it means I have a target to cast the spell on.
    // otherwise, the player had touched on a not available elements for casting the selected spell
    if (eventsRelatedToAvailableSpellTargets.length > 0) {
      Sorcery.castSpell(spell, eventsRelatedToAvailableSpellTargets[0].eventObject, COMMANDERS.PLAYER)
    }
  }
  // =======================================================
  else if (interactionStack.length > 0) {
    const closestEvent = interactionStack.reduce((r: ThreeEvent<Event> | null, e: ThreeEvent<Event>) => {
      if (!r || e.distance < r.distance) {
        r = e
      }
      return r
    }, null)
    if (closestEvent?.eventObject) {
      const gameObject = closestEvent?.eventObject as GameObject3D
      const gameElement = getGameElementFromObj(gameObject) as Interactive
      gameElement.onSelect()
    }
  } else {
    // console.log('nothing in stack')
  }
  interactionStack.length = 0
}
// resolves interaction on pointer out, it does it after the next animation frame
// trying to make sure all the target objects are stored in the interaction stack
document.addEventListener('pointerup', () => requestAnimationFrame(resolveInteraction))

const onPointerDownHandler = (event: ThreeEvent<Event>) => {
  interactionStack.push(event)
}
export default onPointerDownHandler
